/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryActivities.defs.js'
export { main as default } from './queryActivities.defs.js'
